import { BuildInfo } from './environment.type';

export const build: BuildInfo = {
    gitHash: 'bc83b2c',
    branch: 'main',
    date: '2026-02-04T08:57:44.562Z'
};
